import React from 'react'

export default function Header() {
  return (
    <header>
      <div className='container'>
      <div className='topheader'>
      <span><img src='../images/global-software.svg' alt='global software' /></span>
      <span><img src='../images/tally.svg' alt='tally' />  </span>
      </div>
      </div>
      {/* <ul className='address'>
      <li><a href='https://maps.app.goo.gl/uCxTy419RX4ngYaJA' target='_blank' rel='noreferrer'>SUN WESTBANK, B 905-908, Ashram Rd, near VALLABH SADAN, opp. CITY GOLD, Vishalpur, Muslim Society, Navrangpura, Ahmedabad, Gujarat 380009</a></li>
      <li><a href='tel:+91 7966617000'>+91 79 6661 7000</a></li>
      <li><a href='https://globalsoftwares.net/' target='_blank' rel='noreferrer'>www.globalsoftwares.net</a></li>
      <li><a href='mailto:info@globalsoftwares.net'>info@globalsoftwares.net</a></li>
      </ul> */}
    </header>
  )
}
